<script setup lang="ts">
import { transformStoryblokImagesInHtml } from '~/utils/storyblok-image';
const props = defineProps({
    blok: {
        type: Object,
        default: () => ({}),
    },
});

const textRendered = computed(() => {
    return transformStoryblokImagesInHtml(renderRichText(props.blok.text), { width: 1792 });
});
</script>

<template>
    <main class="py-8 lg:py-16 bg-white dark:bg-midnight-blue">
        <div class="flex justify-between px-4 mx-auto max-w-screen-xl">
            <article
                class="mx-auto w-full max-w-4xl format format-h2:text-5xl format-strong:font-bold format-h3:text-3xl format-sm sm:format-base lg:format-lg dark:format-invert"
                v-html="textRendered"
            ></article>
        </div>
    </main>
</template>
